// ── Safari: show only first slide on product cards ──
(function () {
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  if (!isSafari) return;

  const style = document.createElement('style');
  style.textContent = [
    '.card-gallery slideshow-slides { overflow: hidden !important; }',
    '.card-gallery slideshow-slide { display: none !important; }',
    '.card-gallery slideshow-slide:first-child { display: block !important; }',
    '.card-gallery slideshow-arrows { display: none !important; }'
  ].join('\n');
  document.head.appendChild(style);
})();



// ── Redirect spam /magnifierl/ URLs ──
(function () {
  if (window.location.pathname.startsWith('/magnifierl/')) {
    window.location.replace('/');
  }
})();